interface ClaimsIconProps {
  className?: string;
}

export function ClaimsIcon({ className }: ClaimsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Document outline */}
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      {/* Document corner fold */}
      <polyline points="14 2 14 8 20 8" />
      {/* Dollar circle in lower-right area */}
      <circle cx="15" cy="16" r="3.5" />
      {/* Dollar sign */}
      <path d="M15 13.5v5" />
      <path d="M13.5 14.8c0 0 0.6-0.6 1.5-0.6s1.5 0.5 1.5 1.2c0 0.7-0.6 1-1.5 1.2s-1.5 0.5-1.5 1.2c0 0.7 0.6 1.2 1.5 1.2s1.5-0.6 1.5-0.6" />
    </svg>
  );
}
